import React from 'react';
import clsx from 'clsx';

interface ResizeHandleProps {
    maximizedPosition: 'left' | 'right';
    onMouseDown: (e: React.MouseEvent) => void;
}

/**
 * Resize handle component for the StateViewer
 * @param props - Component props
 * @returns Rendered component
 */
const ResizeHandle: React.FC<ResizeHandleProps> = ({
    maximizedPosition,
    onMouseDown,
}) => {
    return (
        <div
            className={clsx(
                'absolute inset-y-0 w-2 cursor-ew-resize',
                maximizedPosition === 'right' ? 'start-0' : 'end-0',
            )}
            onMouseDown={onMouseDown}
            title="Drag to resize"
        />
    );
};

export default ResizeHandle;
